import { CommonState, Fetcher } from '@primeit/components-vue';

const module = {
  actions: {
    FETCH_ALL: async (context, params) => {
      let response;
      let json;

      try {
        response = await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_QUESTIONNAIRE}`);
        if (response.ok) {
          json = await response.json();
        }
      } catch (e) {
        json = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('POPULATE_ALL', json);
    }
  },
  getters: {
    GET_ALL: (state) => {
      if (state.all) {
        return JSON.parse(JSON.stringify(state.all));
      }
    }
  },
  mutations: {
    POPULATE_ALL: (state, payload) => {
      if (payload) {
        state.all = payload;
      }
    }
  },
  namespaced: true,
  state: {
    all: undefined,
  },
};

CommonState.registerModule('questionnaire', module);
